import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'priceFormatter',
  standalone: true,
})
export class PriceFormatterPipe implements PipeTransform {
  transform(minPrice: string, maxPrice : string): string {
    const min = parseFloat(minPrice);
    const max = parseFloat(maxPrice);

    if (min === 0 && max === 0) {
      return 'Free';
    } else if(min === max) {
      return `$${max.toFixed(2)}`;
    } else if (min === 0) {
      return `Free - $${max.toFixed(2)}`;
    } else {
      return `$${min.toFixed(2)} - $${max.toFixed(2)}`;
    }
  }
}
